

























































import { ScheduleModel, ScheduleRequest } from "@/api/types";
import moment, { Moment, now } from "moment";
import { Component, Vue } from "vue-property-decorator";
import ScheduleApi from "@/api/admin/schedule";

@Component
export default class Schedule extends Vue {
  data: ScheduleModel[] = [];
  visible = false;
  modalLoading = false;
  editMode = false;
  datum: ScheduleModel = {
    status: true,
    title: "",
    description: "",
    timeType: 1,
    eventTime: null,
  };
  filter: ScheduleRequest = {
    startDate: this.dateFormat(moment().startOf("month")),
    endDate: this.dateFormat(moment().endOf("month")),
  };

  dateFormat(value: Moment) {
    return moment(value).format("yyyy-MM-DD HH:mm:ss");
  }

  async onPanelChange(value: Moment, mode: string) {
    console.log("value :>> ", value);
    console.log("mode :>> ", mode);
    const result = await ScheduleApi.list({
      startDate: this.dateFormat(value.startOf("month")),
      endDate: this.dateFormat(value.endOf("month")),
    });

    this.data = result.data;
  }

  getListData(value: Moment) {
    return this.data.filter(
      (e: ScheduleModel) =>
        moment(e.eventTime).format("yyyy-MM-DD") ==
        moment(value).format("yyyy-MM-DD")
    );
  }

  async handleOk() {
    this.modalLoading = true;
    try {
      if (this.editMode) {
        await ScheduleApi.update(this.datum);
      } else {
        await ScheduleApi.create(this.datum);
      }
    } catch (error) {
      this.$message.error("작업에 실패하였습니다.");
    }

    this.load();
    this.resetDatum();
    this.modalLoading = false;
    this.visible = false;
  }

  handleCancel() {
    this.visible = false;
    this.resetDatum();
  }

  resetDatum() {
    this.datum = {
      title: "",
      description: "",
      status: true,
      timeType: 1,
      eventTime: null,
    };
    console.log("this.datum :>> ", this.datum);
  }

  mounted() {
    this.load();
  }

  async load() {
    localStorage.removeItem("auth");
    const result = await ScheduleApi.list({
      startDate: this.filter.startDate,
      endDate: this.filter.endDate,
    });
    this.data = result.data;
  }

  async showModal(item?: ScheduleModel) {
    if (item) {
      this.editMode = true;
      const result = await ScheduleApi.single(item.id!);
      this.datum = { ...result };
    }
    this.visible = true;
  }

  async remove(item: ScheduleModel) {
    await ScheduleApi.delete(item.id!);
    await this.load();
  }

  onChange(date: Moment, _: any) {
    this.datum.eventTime = moment(date).toDate();
  }
}
